/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../core";
import { JobOutcome } from "./JobOutcome";
export const JobCompleteDetails = core.serialization.object({
    outcome: JobOutcome.optional(),
    info: core.serialization.string().optional(),
});
